import { UserManager } from 'oidc-client-ts';
import { parseJwt } from '@/utils/helpers';
import { AUTH_CLIENT_ID } from './constants';

const urlParams = new URLSearchParams(window.location.search);
const hasAutoLoginCode =
  window.location.pathname.toLowerCase() === '/autologin' &&
  urlParams.has('code');
let isLoggingOut = false;

const config = {
  authority: process.env.VUE_APP_PERFORMA_API,
  client_id: AUTH_CLIENT_ID,
  redirect_uri: `${window.location.origin}/login`,
  silent_redirect_uri: `${window.location.origin}/silent`,
  post_logout_redirect_uri: window.location.origin,
  automaticSilentRenew: false,
  scope: 'openid profile offline_access performa',
  silentRequestTimeoutInSeconds: 60,
  accessTokenExpiringNotificationTimeInSeconds: 120,
  extraQueryParams: {
    pcv: process.env.VUE_APP_BUILD_VERSION,
  },
  // monitorSession: true,
};

if (hasAutoLoginCode) {
  config.extraQueryParams.autoLoginToken = urlParams.get('code');
}

let user = null;
let postLoginRoute = null;

const getUser = () => {
  return user;
};

const setUser = (newUser) => {
  user = augmentUser(newUser);
  postLoginRoute = newUser.state?.postLoginRoute ?? null;
};

const augmentUser = (userToAugment) => {
  const jwt = parseJwt(userToAugment.access_token) ?? {};
  return {
    ...jwt,
    roles: jwt.rol,
    firstName: jwt.fname,
    lastName: jwt.lname,
    middleName: jwt.mname,
    organizationId: jwt.orgId,
    canEditAnswerOverrides: jwt.ceao,
    id: jwt.sub,
  };
};

const userManager = new UserManager(config);

const refreshToken = async () => {
  try {
    await userManager.signinSilent({
      extraTokenParams: {
        pcv: process.env.VUE_APP_BUILD_VERSION,
      },
    });
  } catch (error) {
    userManager.events._raiseSilentRenewError(error);

    // Retry after 5 seconds;
    if (error.name === 'ErrorTimeout') {
      setTimeout(refreshToken, 5000);
    }
  }
};

userManager.events.addUserLoaded((loadedUser) => {
  user = augmentUser(loadedUser);
});

userManager.events.addAccessTokenExpiring(refreshToken);

userManager.events.addUserSignedOut(async () => {
  if (isLoggingOut) {
    return;
  }

  try {
    isLoggingOut = true;
    // Trigger logout process=
    await userManager.signoutRedirect({ id_token_hint: user?.id_token });
    window.localStorage.clear();
  } catch (error) {
    console.error('Error during logout:', error);
  }
});

// userManager.events.addUserSessionChanged(() => {
//   console.log('User session changed');
//   // Update UI or take necessary actions
// });

export { userManager, getUser, setUser, postLoginRoute };
